import { render } from "./Trailor.vue?vue&type=template&id=87ef9886"
import script from "./Trailor.vue?vue&type=script&lang=js"
export * from "./Trailor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__